import Image from "./Image/Image";
import BackgroundContainer from "./BackgroundContainer/BackgroundContainer";
import RepeatedItems from "./RepeatedItems/RepeatedItems";
import Button from "./Button/Button";
import Video from "./Video/Video";
import SlideShow from "./SlideShow/SlideShow";
import NavMenu from "./NavMenu/NavMenu";
import Icon from "./Icon/IconElement";
import SocialLinks from "./SocialLinks/SocialLinks";
import Form from "./Form/Form";
import Logo from "./Logo/Logo";
import LanguageSwitcher from "./LanguageSwitcher/LanguageSwitcher";
import MobileMenu from "./MobileMenu/MobileMenu";
import DesktopMenu from "./DesktopMenu/DesktopMenu";
import Map from "./Map/Map";
import Embed from "./Embed/Embed";
import HTMLText from "./HTMLText/HTMLText";
import CustomElement from "./CustomElement/CustomElement";
import ImageLightBox from "./Image/ImageLightBox/ImageLightBox";
import FluidElement from "./FluidElement/FluidElement";

export default {
  MobileMenu,
  DesktopMenu,
  Video,
  Text: HTMLText,
  LanguageSwitcher,
  Image,
  BackgroundContainer,
  RepeatedItems,
  Button,
  SlideShow,
  NavMenu,
  Icon,
  SocialLinks,
  Logo,
  Map,
  ViewMap: Map,
  Embed,
  Form,
  HTMLText,
  CustomElement,
  ImageLightBox,
  FluidElement,
};
